<template>
  <div class="video-page-wrapper">
    <IphoneVideo :video-name="require('@/assets/videos/group_device_control.mp4')"></IphoneVideo>
    <div class="video-page-texts">
      <div>
        <h3>{{ $t("pages.group-devices.subtitle1") }}</h3>
        <p>{{ $t("pages.group-devices.text1") }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GroupDevices"
};
</script>

<style scoped lang="scss">
</style>
